export const IMAGE_SIZE_LIMIT = 5 * 1024; // 5MB
export const SOUNDTRACK_SIZE_LIMIT = 300 * 1024; // 5MB

export const isWithinImageSizeLimit = (file) => {
  const fsize = file.size;
  const fileSize = Math.round(fsize / 1024);
  return fileSize < IMAGE_SIZE_LIMIT;
};

export const isWithinSoundtrackSizeLimit = (file) => {
  const fsize = file.size;
  const fileSize = Math.round(fsize / 1024);
  return fileSize < SOUNDTRACK_SIZE_LIMIT;
};

export const isSizeBetweenOneAndTenMB = (file) => {
  const fsize = file.size;
  const fileSize = Math.round(fsize / 1024);
  return fileSize > 1024 && fileSize < 10 * 1024;
};

export const checkCoverSizeAndRatio = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      const image = new Image();
      image.src = e.target.result;
      image.onload = function () {
        const height = this.height;
        const width = this.width;
        if (
          height === width &&
          height >= 1400 &&
          width >= 1400 &&
          height <= 4000 &&
          width <= 4000
        ) {
          resolve(false);
        } else {
          resolve(true);
        }
      };
    };
  });
};

export const checkIfCardCollapsible = (medium) => {
  return medium?.description || medium?.title?.length > 55;
};

export const getMiddleColumn = () =>
  window.document.getElementById("middle_col");
